import { apiAuthWithToken } from './axiosAuth'

export function getAllUserWeb(params) {
  return apiAuthWithToken.get('/customer/get-list-customer', { params })
}
export async function userDetailWeb(id) {
  try {
    const response = await apiAuthWithToken.get(
      `/customer/admin/customer-details?userId=${id}`
    )

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}
export async function userWebUpdate(body, id) {
  const response = await apiAuthWithToken.post(
    `/customer/admin/update-user`,
    body
  )
  return response
}

export default { getAllUserWeb, userDetailWeb }
